export const PFA_STATUS = {
  EXCELLENT: "EXCELLENT",
  SATISFACTORY: "SATISFACTORY",
  UNSATISFACTORY: "UNSATISFACTORY",
} as const;

export type PFAStatus = (typeof PFA_STATUS)[keyof typeof PFA_STATUS];

export const PUSH_UP_OPTION = {
  ONE_MIN: "ONE_MIN_PUSH_UP",
  TWO_MIN_HAND_RELEASE: "TWO_MIN_HAND_RELEASE",
} as const;

export type PushUpOption = (typeof PFA_STATUS)[keyof typeof PFA_STATUS];

export const CARDIORESPIRATORY_ENDURANCE_OPTION = {
  ONE_MIN: "1_5_MILE_RUN_TIME_IN_SECONDS",
  HAMR_SHUTTLES: "HAMR_SHUTTLES",
} as const;

export type CardiorespiratoryEnduranceOption =
  (typeof CARDIORESPIRATORY_ENDURANCE_OPTION)[keyof typeof CARDIORESPIRATORY_ENDURANCE_OPTION];

export const CORE_MUSCLE_ENDURANCE_OPTION = {
  ONE_MIN: "ONE_MIN_CORE_MUSCLE_ENDURANCE",
  TWO_MIN_CROSS_LEG_REVERSE_CRUNCH: "TWO_MIN_CROSS_LEG_REVERSE_CRUNCH",
  FOREARM_PLANK_IN_SECONDS: "FOREARM_PLANK_IN_SECONDS",
} as const;

export type CoreMuscleEnduranceOption =
  (typeof CORE_MUSCLE_ENDURANCE_OPTION)[keyof typeof CORE_MUSCLE_ENDURANCE_OPTION];

export interface PhysicalFitnessAssessment {
  date: string;
  cardiorespiratory_endurance_option: CardiorespiratoryEnduranceOption;
  cardiorespiratory_endurance_value: number;
  cardiorespiratory_endurance_score: number;
  push_up_option: PushUpOption;
  push_up_value: number;
  push_up_score: number;
  core_muscle_endurance_option: CoreMuscleEnduranceOption;
  core_muscle_endurance_value: number;
  core_muscle_endurance_score: number;
  total_score: number;
  status: PFAStatus;
}
